var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewfivestarstuck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 12,
    viewBox: "0 0 64 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_2268_408)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02408 6.66419L8.89266 5.36314L9.00707 5.28659L6.61884 5.38925L5.99999 3.01021L5.37681 5.39311L3.0071 5.30523L4.99861 6.67048L4.18412 8.97779L6.01377 7.44829L7.87212 9.00442L7.02408 6.66419Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint1_linear_2268_408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0241 6.66419L21.8927 5.36314L22.0071 5.28659L19.6188 5.38925L19 3.01021L18.3768 5.39311L16.0071 5.30523L17.9986 6.67048L17.1841 8.97779L19.0138 7.44829L20.8721 9.00442L20.0241 6.66419Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint2_linear_2268_408)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0241 6.66419L34.8927 5.36314L35.0071 5.28659L32.6188 5.38925L32 3.01021L31.3768 5.39311L29.0071 5.30523L30.9986 6.67048L30.1841 8.97779L32.0138 7.44829L33.8721 9.00442L33.0241 6.66419Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint3_linear_2268_408)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0241 6.66419L47.8927 5.36314L48.0071 5.28659L45.6188 5.38925L45 3.01021L44.3768 5.39311L42.0071 5.30523L43.9986 6.67048L43.1841 8.97779L45.0138 7.44829L46.8721 9.00442L46.0241 6.66419Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint4_linear_2268_408)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0241 6.66419L60.8927 5.36314L61.0071 5.28659L58.6188 5.38925L58 3.01021L57.3768 5.39311L55.0071 5.30523L56.9986 6.67048L56.1841 8.97779L58.0138 7.44829L59.8721 9.00442L59.0241 6.66419Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2268_408",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E7D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6C5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2268_408",
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E7D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6C5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2268_408",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E7D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6C5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2268_408",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E7D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6C5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2268_408",
    x1: 58,
    y1: 0,
    x2: 58,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E7D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfivestarstuck);
export default __webpack_public_path__ + "static/media/newfivestarstuck.1703f10aae4e11061e26f12623df1e87.svg";
export { ForwardRef as ReactComponent };